import PageHeadingImplementation from '../implementation/shared/PageHeading';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiPageHeadingDTO,
  PageHeadingDTO,
} from '@lib/strapi/dtos/components/shared/pageHeading.dto';

const PageHeading = (props: ComponentProps<PageHeadingDTO>) => {
  return <PageHeadingImplementation {...props}></PageHeadingImplementation>;
};

export default PageHeading;
